/**
 * Magnolia Kids · adaptador del tema Crescendo (Cello).
 *
 * Todo lo que depende del DOM de Crescendo vive aquí; la lógica comercial está en assets/mk-core.js (window.MK),
 * que debe cargarse ANTES. Al cambiar de tema se reescribe solo este archivo.
 * El HTML que se inserta sale de <template> renderizados en Liquid (snippets/mk-commerce-config.liquid y
 * layout/theme.liquid), así el precio y los textos llegan desde Shopify y no hay parpadeo.
 *
 * Ficha de producto (`product-info`):
 *  - línea de cuotas bajo el precio (`.wbpricetax`), al día cuando cambia la variante (pack) o llega `mk:selection`.
 *  - estimador de envío bajo el formulario de compra (`product-form`).
 * Carrito (cajón y página): bajo `.totals` va la línea de cuotas y el envío/total estimado, con el total de /cart.js
 *  (después de descuentos, sin despacho). El cajón se vuelve a pintar entero al cambiar el carrito, así que se
 *  vigila el DOM y se vuelve a montar.
 */
(function () {
  if (!window.MK) return;

  var MK = window.MK;
  var line = null;
  var est = null;
  var prices = null; // variantId -> precio en pesos, desde /products/<handle>.js

  function render(el, pesos) {
    if (!el || !(pesos > 0)) return;
    var c = MK.cuotas(pesos);
    el.dataset.mkPrice = pesos;
    el.querySelector('.mp-cuotas-count').textContent = c.n;
    el.querySelector('.mp-cuota-amount').textContent = c.each.toLocaleString('es-CL');
    el.querySelector('.mp-cuota-approx').hidden = !c.approx;
  }

  function fillRegions(select, first) {
    if (select.options.length > 1) return;
    select.innerHTML = '<option value="">' + first + '</option>' + MK.config.regions.map(function (r) {
      return '<option value="' + r.name.replace(/"/g, '&quot;') + '">' + r.name + '</option>';
    }).join('');
  }

  // --- Ficha de producto: cuotas ---

  function mountLine() {
    if (line) return line;
    var tpl = document.getElementById('mk-cuotas-tpl');
    var info = document.querySelector('product-info');
    var anchor = info && info.querySelector('.wbpricetax');
    if (!tpl || !anchor) return null;
    anchor.insertAdjacentHTML('afterend', tpl.innerHTML.trim());
    line = anchor.nextElementSibling;
    tpl.remove();
    return line;
  }

  function currentVariantId() {
    var input = document.querySelector('product-info input[name="id"]');
    return input ? input.value : '';
  }

  function fromVariant() {
    var id = currentVariantId();
    if (prices && prices[id]) render(line, prices[id]);
    renderEstimator();
  }

  function loadPrices() {
    return fetch(window.location.pathname.replace(/\/$/, '') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        prices = {};
        p.variants.forEach(function (v) { prices[String(v.id)] = v.price / 100; });
        fromVariant();
      })
      .catch(function () {});
  }

  // --- Ficha de producto: estimador de envío ---

  function mountEstimator() {
    if (est) return est;
    var tpl = document.getElementById('mk-est-tpl');
    var form = document.querySelector('product-info product-form');
    if (!tpl || !form) return null;
    form.insertAdjacentHTML('afterend', tpl.innerHTML.trim());
    est = form.nextElementSibling;
    tpl.remove();
    var select = est.querySelector('.mk-est__select');
    fillRegions(select, 'Selecciona tu región...');
    select.value = MK.getRegion();
    select.addEventListener('change', function () { MK.setRegion(select.value); });
    return est;
  }

  function estimatorPrice() {
    var s = window.MKSelection;
    var id = currentVariantId();
    if (prices && prices[id]) return prices[id];
    if (s && String(s.variantId) === String(id) && s.pesos > 0) return s.pesos;
    return Number(est.dataset.price) || 0;
  }

  function renderEstimator() {
    if (!est) return;
    var select = est.querySelector('.mk-est__select');
    var res = est.querySelector('.mk-est__result');
    var name = MK.getRegion();
    if (select.value !== name) select.value = name;
    if (!name) {
      res.innerHTML = '<span>Selecciona tu región para estimar el envío</span>';
      return;
    }
    var pesos = estimatorPrice();
    var q = MK.quote(pesos, name);
    var std = q.free
      ? '<span class="mk-est__free">Gratis</span>'
      : '<span style="font-weight:500;">' + MK.fmt(q.standard) + '</span>';
    var html = 'Envío estándar estimado: ' + std;
    if (pesos > 0) html += '<br><span class="mk-est__small">Para tu selección de ' + MK.fmt(pesos) + '</span>';
    var transit = q.region.min === q.region.max ? String(q.region.min) : q.region.min + '–' + q.region.max;
    res.innerHTML = html + '<br><span>Tránsito estimado: ' + transit + ' días hábiles desde el despacho.</span>'
      + '<br><span class="mk-est__small">Considera además hasta 1 día hábil de preparación. El plazo puede variar según la comuna y el transportista.</span>'
      + '<br><span class="mk-est__small">El costo final del envío se confirma al ingresar tu dirección en el pago.</span>';
  }

  function initProduct() {
    if (!mountLine()) return;
    mountEstimator();
    renderEstimator();
    loadPrices();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') fromVariant();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(fromVariant, 0); });
    }
    document.addEventListener('mk:selection', function (e) {
      if (e.detail && e.detail.pesos) render(line, e.detail.pesos);
      renderEstimator();
    });
  }

  // --- Carrito: cuotas y envío/total estimados ---

  var CART_TOTALS = '.cart-drawer__footer .totals, .cart__footer .totals';
  var cartTotal = 0;
  var shipOpen = false; // el cajón se repinta entero: el estado del selector se guarda aquí

  function renderCartShip(el) {
    var total = cartTotal;
    var name = MK.getRegion();
    var free = total >= MK.config.threshold; // envío estándar gratis: no depende de la región
    var q = MK.quote(total, name);
    var select = el.querySelector('.mk-ship__select');
    fillRegions(select, 'Selecciona tu región…');
    if (select.value !== name) select.value = name;
    var val = el.querySelector('[data-ship-val]');
    var toggle = el.querySelector('[data-ship-toggle]');
    el.hidden = !(total > 0);
    // Con envío estándar gratis no se pide la región; con costo, el selector se despliega al tocar "Estimar envío".
    toggle.hidden = free;
    el.querySelector('[data-ship-panel]').hidden = free || !shipOpen;
    el.querySelector('[data-ship-note]').hidden = free;
    toggle.textContent = name ? 'Cambiar región' : 'Estimar envío';
    if (free) {
      val.textContent = 'Gratis';
      val.className = 'mk-ship__val mk-ship__val--free';
      el.querySelector('[data-total-val]').textContent = MK.fmt(total);
    } else if (q) {
      val.textContent = MK.fmt(q.standard);
      val.className = 'mk-ship__val';
      el.querySelector('[data-total-val]').textContent = MK.fmt(total + q.standard);
    } else {
      val.textContent = 'Por estimar';
      val.className = 'mk-ship__val mk-ship__val--pending';
      el.querySelector('[data-total-val]').textContent = MK.fmt(total);
    }
  }

  function renderCart() {
    document.querySelectorAll('[data-mk-cart-cuotas]').forEach(function (el) {
      el.hidden = !(cartTotal > 0);
      render(el, cartTotal);
    });
    document.querySelectorAll('[data-mk-cart-ship]').forEach(renderCartShip);
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartTotal = cart.total_price / 100;
        renderCart();
      })
      .catch(function () {});
  }

  function mountCart() {
    var cuotasTpl = document.getElementById('mk-cuotas-cart-tpl');
    var shipTpl = document.getElementById('mk-cart-ship-tpl');
    if (!cuotasTpl || !shipTpl) return;
    var added = false;
    document.querySelectorAll(CART_TOTALS).forEach(function (totals) {
      var cuotas = totals.nextElementSibling;
      if (!cuotas || !cuotas.hasAttribute('data-mk-cart-cuotas')) {
        totals.insertAdjacentHTML('afterend', cuotasTpl.innerHTML.trim());
        cuotas = totals.nextElementSibling;
        cuotas.setAttribute('data-mk-cart-cuotas', '');
        added = true;
      }
      var ship = cuotas.nextElementSibling;
      if (!ship || !ship.hasAttribute('data-mk-cart-ship')) {
        cuotas.insertAdjacentHTML('afterend', shipTpl.innerHTML.trim());
        added = true;
      }
    });
    if (added) {
      renderCart();
      refreshCart();
    }
  }

  function initCart() {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; mountCart(); });
    }).observe(document.body, { childList: true, subtree: true });
    // Delegado: el cajón reemplaza los nodos al repintarse.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('mk-ship__select')) {
        shipOpen = false;
        MK.setRegion(e.target.value);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target instanceof Element && e.target.closest('[data-ship-toggle]')) {
        shipOpen = !shipOpen;
        renderCart();
      }
    });
    mountCart();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCart, 400); });
    }
  }

  function init() {
    initProduct();
    initCart();
    document.addEventListener('mk:region', function () {
      renderEstimator();
      renderCart();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
